// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.tw-news_news_kYK35 {
  background: var(--motion-tertiary);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.375rem 0;
  gap: 0.5rem;
}

.tw-news_text_VMc__ {
  flex-grow: 1;
  color: white;
  text-align: center;

  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.tw-news_text_VMc__ a {
  color: inherit;
}

.tw-news_close_Wx9qB {
  flex-shrink: 0;
  margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/tw-news.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.news {\n  background: var(--motion-tertiary);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.375rem 0;\n  gap: 0.5rem;\n}\n\n.text {\n  flex-grow: 1;\n  color: white;\n  text-align: center;\n\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.text a {\n  color: inherit;\n}\n\n.close {\n  flex-shrink: 0;\n  margin-right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"news": `tw-news_news_kYK35`,
	"text": `tw-news_text_VMc__`,
	"close": `tw-news_close_Wx9qB`
};
export default ___CSS_LOADER_EXPORT___;
